import clsx from 'clsx';
import { ReactNode } from 'react';
import Close from '../../svg/16x16/Cross16.svg';
import Info from '../../svg/Info.svg';
import Tick from '../../svg/TickCircle.svg';
import Warning from '../../svg/Warning.svg';
import styles from './base.module.css';

type IconType = 'info' | 'warning' | 'tick';

const Icon = ({ icon }: { icon?: IconType }) => {
  switch (icon) {
    case 'info':
      return <Info />;
    case 'warning':
      return <Warning />;
    case 'tick':
      return <Tick />;
    default:
      return <Info />;
  }
};

interface BaseCalloutOrToastProps {
  callToAction?: ReactNode;
  close: () => void;
  color?: 'grey' | 'teal' | 'orange';
  content: ReactNode;
  icon?: IconType;
  type?: 'callout' | 'toast';
  timeout?: number;
}

const BaseCalloutOrToast = ({
  callToAction,
  close,
  color = 'grey',
  content,
  icon = 'info',
  type = 'callout',
}: BaseCalloutOrToastProps) => {
  return (
    <div
      className={clsx(
        styles.baseCalloutOrToast,
        type && styles[`base__${type}`],
      )}
    >
      {type === 'toast' && (
        <div
          className={clsx(styles.sideColor, color && styles[`color__${color}`])}
        />
      )}
      <div className={styles.baseContainer}>
        <div className={styles.baseContent}>
          <div className={clsx(styles.icon, color && styles[`icon__${color}`])}>
            <Icon icon={icon} />
          </div>
          <div>{content}</div>
        </div>
        <div className={styles.actions}>
          {callToAction && <div>{callToAction}</div>}
          <button
            onClick={() => close()}
            aria-label="Close callout"
            className={clsx(styles.close, 'buttonReset')}
          >
            <Close />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BaseCalloutOrToast;
